import { SET_TABLE_ONE_EVENT_TPA_REPORT, SET_TABLE_TWO_STOCK_TPA_REPORT, SET_TABLE_THREE_SHRINKAGE_TPA_REPORT,SET_TABLE_FOUR_ONSHORE_TPA_REPORT } from "./actionType";
const initialState = {
  tableOneEventTPA: [],
  tableTwoStockTPA: {},
  tableThreeShrinkageTPA: [],
  tableFourOnshoreTPA:{},
  
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_TABLE_ONE_EVENT_TPA_REPORT:
      return { ...state, tableOneEventTPA: payload };

    case SET_TABLE_TWO_STOCK_TPA_REPORT:
      return { ...state, tableTwoStockTPA: payload };

    case SET_TABLE_THREE_SHRINKAGE_TPA_REPORT:
      return { ...state, tableThreeShrinkageTPA: payload };

    case SET_TABLE_FOUR_ONSHORE_TPA_REPORT:
      return { ...state, tableFourOnshoreTPA: payload };


    default:
      return state;
  }
};
